import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, TextField, IconButton } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

const ChatbotMessageInput = ({ onSendMessage }) => {
  const [message, setMessage] = useState("");

  const handleSendMessage = () => {
    if (message.trim() !== "") {
      onSendMessage(message);
      setMessage("");
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mt: 2,
        backgroundColor: "background.paper",
        borderRadius: "borderRadius",
        boxShadow: 1,
        px: 2,
        py: 1,
      }}
    >
      <TextField
        fullWidth
        label="Type your message..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyPress={handleKeyPress}
        variant="outlined"
        size="small"
      />
      <IconButton color="primary" onClick={handleSendMessage}>
        <SendIcon />
      </IconButton>
    </Box>
  );
};

ChatbotMessageInput.propTypes = {
  onSendMessage: PropTypes.func.isRequired,
};

export default ChatbotMessageInput;
